'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';


export function TaskProgressView(props) {
  return (
    <div className={classNames("TaskProgress TaskProgress__single", props.className)}>
      <span className="TaskProgress__single__label">
        {`${props.statusLabel}:`}
      </span>
      <span className={'TaskProgress__single__status ' + getCurrentStatusClass(props.status)}>
        {props[getCurrentStatusLabel(props.status)]}
      </span>
    </div>
  );
}

function getCurrentStatusClass(status) {
  switch (status) {
    case 'cancelled':
      return 'TaskProgress__current TaskProgress__current_cancel';

    case 'pending':
    case 'in_progress':
    case 'submitted':
      return 'TaskProgress__current TaskProgress__current_default';

    case 'has_rejection':
    case 'has_rejections':
    case 'rejected':
      return 'TaskProgress__current TaskProgress__current_rejected';

    case 'approved':
      return 'TaskProgress__current TaskProgress__current_complete';

    default:
      return '';
  }
}

function getCurrentStatusLabel(status) {
  switch (status) {
    case 'has_rejection':
    case 'has_rejections':
      return 'has_rejectionLabel';

    default:
      return `${status}Label`;
  }
}

TaskProgressView.propTypes = {
  className: T.string,
  status: T.string,

  statusLabel: T.string,
  cancelledLabel: T.string,
  has_rejectionLabel: T.string,
  pendingLabel: T.string,
  in_progressLabel: T.string,
  submittedLabel: T.string,
  approvedLabel: T.string,
};

TaskProgressView.messages = [
  {code: 'status.label', prop: 'statusLabel'},
  {code: 'status.cancelled.label', prop: 'cancelledLabel'},
  {code: 'status.rejected.label', prop: 'rejectedLabel'},
  {code: 'status.has_rejection.label', prop: 'has_rejectionLabel'},
  {code: 'status.pending.label', prop: 'pendingLabel'},
  {code: 'status.in_progress.label', prop: 'in_progressLabel'},
  {code: 'status.submitted.label', prop: 'submittedLabel'},
  {code: 'status.approved.label', prop: 'approvedLabel'},
];

TaskProgressView.messageProps = [
  'statusLabel',
  'cancelledLabel',
  'rejectedLabel',
  'has_rejectionLabel',
  'pendingLabel',
  'in_progressLabel',
  'submittedLabel',
  'approvedLabel',
];



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskProgress/TaskProgressView.js